import { differenceInCalendarDays, format, isValid, parse } from 'date-fns';

export const SUBSCRIPTION_WARNING_DAYS = 7;

export const SUBSCRIPTION_BLOCKED_TITLE = "Subscription expired";
export const SUBSCRIPTION_BLOCKED_MESSAGE =
    "Your subscription has expired. Please connect with InnPro to renew it.";

const EXPIRY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// Strictly parse "yyyy-MM-dd" as a local calendar date. Returns null if empty or invalid.
export function getSubscriptionExpiryDate(hotel) {
    const value = hotel?.subscriptionExpiresOn;
    if (typeof value !== 'string' || !EXPIRY_PATTERN.test(value)) {
        return null;
    }
    // date-fns rejects impossible dates such as 2026-02-30.
    const date = parse(value, 'yyyy-MM-dd', new Date());
    return isValid(date) ? date : null;
}

// Whole calendar days from today (local date) to the expiry date.
// 0 on the expiry day, negative after it, null when there's no valid date.
export function getSubscriptionDaysLeft(hotel, today = new Date()) {
    const expiryDate = getSubscriptionExpiryDate(hotel);
    if (!expiryDate) {
        return null;
    }
    // Compares year/month/day only, so time of day and DST shifts don't matter.
    return differenceInCalendarDays(expiryDate, today);
}

// Active through the expiry date (inclusive), inactive from the next day.
// A missing, null, empty or invalid date counts as ACTIVE.
export function isSubscriptionActive(hotel) {
    const daysLeft = getSubscriptionDaysLeft(hotel);
    return daysLeft === null || daysLeft >= 0;
}

// Still active, but expiring within 0..7 days (inclusive).
export function isSubscriptionExpiringSoon(hotel) {
    const daysLeft = getSubscriptionDaysLeft(hotel);
    return daysLeft !== null && daysLeft >= 0 && daysLeft <= SUBSCRIPTION_WARNING_DAYS;
}

// DD-MMM-YYYY, e.g. 30-Sep-2026. Empty string when there's no valid date.
export function formatSubscriptionExpiry(hotel) {
    const expiryDate = getSubscriptionExpiryDate(hotel);
    return expiryDate ? format(expiryDate, 'dd-MMM-yyyy') : "";
}

export function findHotel(hotels, hotelId) {
    if (!hotelId || !Array.isArray(hotels)) {
        return undefined;
    }
    const id = String(hotelId).toLowerCase();
    return hotels.find(hotel => String(hotel?.id).toLowerCase() === id);
}

// The app has no toast/snackbar component; errors are reported with alert() throughout.
export function notifySubscriptionBlocked() {
    alert(`${SUBSCRIPTION_BLOCKED_TITLE}\n\n${SUBSCRIPTION_BLOCKED_MESSAGE}`);
}
